import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,_vm._b({},'v-row',_vm.$attrs,false),_vm._l((_vm.items),function(item,index){return _c(VCol,_vm._b({key:index,staticClass:"my-0 py-0"},'v-col',_vm.getAttrs(item),false),[_vm._t("item",null,{"item":item,"attrs":_vm.getAttrs(item)})],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }